import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { toFriendlyDateString } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  receipt_header: {
    margin: '5px -20px 10px -20px',
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
  },
  payment_details: {
    fontSize: '12px',
    fontFamily: 'Circular',
  },
};

class HistoricPayments extends Component {
  render() {
    const data = this.props.data;
    if (!data || !data.historic_payments) return null;

    return (
      <div>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <h4 style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('transactions.paymentHistory')}
            </h4>
          </div>
        </div>

        <div className="row" style={{ margin: 'auto', maxWidth: '500px' }}>
          <div className="row">
            <div className="col-xs-3" style={{ padding: '0' }}>
              <h6 style={{ marginBottom: '5px' }}> {getTranslatedString('transactions.date')}</h6>
            </div>
            <div className="col-xs-3" style={{ padding: '0' }}>
              <h6 style={{ marginBottom: '5px' }}>
                {' '}
                {getTranslatedString('transactions.amountPaid')}
              </h6>
            </div>
            <div className="col-xs-3" style={{ padding: '0' }}>
              <h6 style={{ marginBottom: '5px' }}>
                {' '}
                {getTranslatedString('transactions.referenceNumberAbr')}
              </h6>
            </div>
            <div className="col-xs-3" style={{ padding: '0' }}>
              <h6 style={{ marginBottom: '5px' }}>
                {' '}
                {getTranslatedString('tenantPortal.historicPayments.tenant')}
              </h6>
            </div>
          </div>

          {data.historic_payments.map((payment, index) => (
            <div key={index} className="row">
              <div className="col-xs-3" style={{ padding: '0', wordBreak: 'break-word' }}>
                <p style={style.payment_details}>
                  {toFriendlyDateString(payment.date, { language: this.props.currentLanguage })}
                </p>
              </div>
              <div className="col-xs-3" style={{ padding: '0', wordBreak: 'break-word' }}>
                <p style={style.payment_details}>{payment.amount}</p>
              </div>
              <div className="col-xs-3" style={{ padding: '0', wordBreak: 'break-word' }}>
                <p style={style.payment_details}>{payment.ref_number}</p>
              </div>
              <div className="col-xs-3" style={{ padding: '0', wordBreak: 'break-word' }}>
                <p style={style.payment_details}>{payment.tenant}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

HistoricPayments = connect(state => ({
  currentLanguage: state.locale.currentLanguage,
}))(HistoricPayments);

export default localize()(HistoricPayments);
